<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
    <fakturnia-vertical-navigation class="light bg-white print:hidden" [mode]="'over'" [name]="'mainNavigation'"
        [navigation]="navigation" [opened]="false">
        <!-- Navigation header hook -->
        <ng-container fakturniaVerticalNavigationContentHeader>
            <a [routerLink]="'/'">
                <!-- Logo -->
                <div class="flex items-center pt-6 px-8 mb-6 ">
                    <img class="w-full mx-auto rounded-xl" src="assets/images/logo_long.png" alt="Logo image"><br />
                </div>
            </a>
        </ng-container>
    </fakturnia-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 sm:h-18 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">

        <ng-container *ngIf="!isScreenSmall">
            <ng-container fakturniaVerticalNavigationContentHeader>
                <div class="flex items-center px-8">
                    <a [routerLink]="'/'">
                        <div class="flex items-center pr-8 ">
                            <img class="h-10 w-10 mx-auto rounded-xl" src="assets/images/logo.svg" alt="Logo image">
                            <!-- <img class="hidden xl:block w-24 mx-auto rounded-xl" src="assets/images/logo_long.png" alt="Logo image"><br /> -->
                        </div>
                    </a>
                </div>
            </ng-container>
            <!-- Horizontal navigation -->
            <fakturnia-horizontal-navigation class="mr-2" [name]="'mainNavigation'" [navigation]="horizontalNavigation">
            </fakturnia-horizontal-navigation>
            <app-notification-bell *ngIf="isLoggedIn"></app-notification-bell>
        </ng-container>

        <!-- Navigation toggle button -->
        <ng-container *ngIf="isScreenSmall">
            <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
        </ng-container>


        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">

            <a *ngIf="isLoggedIn && showPlanner" mat-button [routerLink]="'/account/management/planner'" [class.text-primary-600]="isPlannerActive" [class.dark:text-primary-400]="isPlannerActive">
                <div class="relative flex items-center">
                    <mat-icon [svgIcon]="'tabler_outline:calendar-check'" [class.text-primary-600]="isPlannerActive" [class.dark:text-primary-400]="isPlannerActive"></mat-icon>
                    <span class="ml-1">Planner</span>
                    <span *ngIf="plannerUpdatesCount > 0" class="absolute -top-1.5 -right-3.5 min-w-[16px] h-4 px-1 rounded-full bg-blue-500 text-white text-[9px] font-bold flex items-center justify-center">
                        {{ plannerUpdatesCount }}
                    </span>
                </div>
            </a>

            <a *ngIf="isLoggedIn && showManager" mat-button [routerLink]="'/account/manager'" [class.text-primary-600]="isManagerActive" [class.dark:text-primary-400]="isManagerActive">
                <mat-icon [svgIcon]="'tabler_outline:device-laptop'" [class.text-primary-600]="isManagerActive" [class.dark:text-primary-400]="isManagerActive"></mat-icon>
                <span class="ml-1">Manager</span>
            </a>

            <a *ngIf="isLoggedIn && showLedger" mat-button [routerLink]="'/account/ledger'" [class.text-primary-600]="isLedgerActive" [class.dark:text-primary-400]="isLedgerActive">
                <mat-icon [svgIcon]="'tabler_outline:report-analytics'" [class.text-primary-600]="isLedgerActive" [class.dark:text-primary-400]="isLedgerActive"></mat-icon>
                <span class="ml-1">Ledger</span>
            </a>

            <a *ngIf="isLoggedIn && showGarage" mat-button [routerLink]="'/account/garage'" [class.text-primary-600]="isGarageActive" [class.dark:text-primary-400]="isGarageActive">
                <mat-icon [svgIcon]="'tabler_outline:tool'" [class.text-primary-600]="isGarageActive" [class.dark:text-primary-400]="isGarageActive"></mat-icon>
                <span class="ml-1">Garage</span>
            </a>

            <a *ngIf="isLoggedIn && showYardOps" mat-button [routerLink]="'/account/yard-ops'" [class.text-primary-600]="isYardOpsActive" [class.dark:text-primary-400]="isYardOpsActive">
                <mat-icon [svgIcon]="'tabler_outline:truck'" [class.text-primary-600]="isYardOpsActive" [class.dark:text-primary-400]="isYardOpsActive"></mat-icon>
                <span class="ml-1">Yard Ops</span>
            </a>

            <a *ngIf="isLoggedIn && showManagement" mat-button [routerLink]="'/account/management'" [class.text-primary-600]="isAdminActive" [class.dark:text-primary-400]="isAdminActive">
                <mat-icon [svgIcon]="'tabler_outline:pencil-cog'" [class.text-primary-600]="isAdminActive" [class.dark:text-primary-400]="isAdminActive"></mat-icon>
                <span class="ml-1">Admin</span>
            </a>

            <fakturnia-fullscreen *ngIf="isLoggedIn" class="hidden md:block"></fakturnia-fullscreen>
            <user *ngIf="isLoggedIn"></user>

        </div>

        <mat-progress-bar class="absolute bottom-0 -mx-6 px-0" *ngIf="isSynchronizing"
            mode="indeterminate"></mat-progress-bar>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto w-full overflow-x-hidden bg-default">
        <!-- *ngIf="true" layout changes won't be registered without *ngIf=true! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

</div>